import React, { useMemo } from 'react';
import { Anchor, ListItemType } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { EMPTY_FIELD_VALUE } from '@/common/constants';
import { ClaimCardsListItem, LockboxClaim } from '@/modules/employer/components/Lockbox/lockbox.types';
import { formatCurrency } from '@/utils';

interface Props {
  lockboxClaims?: LockboxClaim[];
}

const useClaimsCardsList = ({ lockboxClaims }: Props) => {
  const fields: ClaimCardsListItem[] = useMemo(() => {
    if (!lockboxClaims?.length) {
      return [];
    }

    return lockboxClaims?.map((lockboxClaim) => ({
      id: `${lockboxClaim?.claimId}`,
      warnings: lockboxClaim?.labelTypes,
      fields: [
        {
          key: 'claimId',
          type: ListItemType.Text,
          title: 'Claim number',
          style: { fontWeight: 700 },
          ...lockboxClaim?.claimId ? {
            node: (
              <Anchor href={ROUTES.CLAIMS_PROCESSOR(lockboxClaim?.claimId)} target="_blank">
                {lockboxClaim?.claimId}
              </Anchor>
            )
          } : {
            value: lockboxClaim?.claimId || EMPTY_FIELD_VALUE
          }
        },
        {
          key: 'employeeName',
          type: ListItemType.Text,
          title: 'Employee',
          style: { fontWeight: 700 },
          ...lockboxClaim?.employeeId ? {
            node: (
              <Anchor href={ROUTES.EMPLOYEE_VIEW(lockboxClaim?.employeeId)} target="_blank">
                {lockboxClaim?.employeeName}
              </Anchor>
            )
          } : {
            value: lockboxClaim?.employeeName || EMPTY_FIELD_VALUE,
          },
        },
        {
          key: 'claimAmount',
          type: ListItemType.Text,
          title: 'Claim amount',
          value: formatCurrency(lockboxClaim?.claimAmount) || EMPTY_FIELD_VALUE,
          style: { fontWeight: 700 },
        },
        {
          key: 'repaymentAmount',
          type: ListItemType.Text,
          title: 'Repayment required',
          value: formatCurrency(lockboxClaim?.availableForRepaymentAmount) || EMPTY_FIELD_VALUE,
          style: { fontWeight: 700 },
        },
      ],
    }));
  }, [lockboxClaims]);

  return {
    fields,
  };
};

export default useClaimsCardsList;
